import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import {OrderService} from "../services/order.service";
import {Order} from "../models/order";

@Injectable()
export class OrderResolve implements Resolve<Order> {
    constructor(private orderService: OrderService) {}

    resolve(route: ActivatedRouteSnapshot): Observable<Order> {
        return this.orderService.getById(route.params.id);
    }
}